export enum FormatFile {
  PDF = 'PDF',
  XLSX = 'XLSX',
  CSV = 'CSV'
}

export const optionsFormatExport = [
  {
    id: 1,
    title: 'CSV',
    label: FormatFile.CSV,
    type: FormatFile.CSV,
    color: '#239706'
  },
  {
    id: 2,
    title: 'PDF',
    label: FormatFile.PDF,
    type: FormatFile.PDF,
    color: '#D22419'
  },
  {
    id: 3,
    title: 'EXCEL',
    label: FormatFile.XLSX,
    type: FormatFile.XLSX,
    color: '#3CD82F'
  }
] as const;

export const MAXIMUN_ROWS_IN_PDF = 15000;
export const MESSAGE_ERROR_PDF = 'errorMessages.exportLimitExceeded';
